<template>
  <back-section :menu="nama" />
  <ListDataApprove />
</template>
<script>
import ListDataApprove from "@/components/Approval/ListDataPhApprove.vue";
import BackSection from "@/components/BackSection.vue";
export default {
  setup() {
    return {
      nama: "List Approval Pegawai PH",
    };
  },
  components: { BackSection, ListDataApprove },
};
</script>
